import { render } from "./RecentSendList.vue?vue&type=template&id=3e3aec9d"
import script from "./RecentSendList.vue?vue&type=script&lang=js"
export * from "./RecentSendList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__